// Declarar a função gtag_report_conversion do Google Ads
declare global {
  interface Window {
    gtag_report_conversion: (url?: string) => boolean;
  }
}

const HeroSection = () => {
  const handleWhatsApp = () => {
    // Registrar conversão do Google Ads antes de abrir o WhatsApp
    if (typeof window.gtag_report_conversion === 'function') {
      window.gtag_report_conversion();
    }
    window.open('https://wa.me/5519981868997', '_blank');
  };

  const handleCall = () => {
    // Registrar conversão do Google Ads antes de fazer a ligação
    if (typeof window.gtag_report_conversion === 'function') {
      window.gtag_report_conversion();
    }
    window.location.href = 'tel:+5519981868997';
  };

  return (
    <section
      id="home"
      className="relative py-20 overflow-hidden"
      style={{
        backgroundImage: 'url(https://static.readdy.ai/image/df7ad06493c3871277717cdaf248fafe/6bf3da5f57507d996ca12f61e7ac1f2c.webp)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-gradient-to-r from-blue-900/90 to-green-900/80"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col lg:flex-row items-center">
          <div className="w-full lg:w-1/2 text-center lg:text-left mb-12 lg:mb-0">
            <h1 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              DESENTUPIDORA EM CAMPINAS E REGIÃO
            </h1>
            <h2 className="text-2xl lg:text-3xl font-semibold text-green-300 mb-6">
              Soluções Rápidas em Desentupimento
            </h2>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start space-y-4 sm:space-y-0 sm:space-x-6 mb-8">
              <div className="flex items-center space-x-2 text-white">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                  <i className="ri-time-line text-sm"></i>
                </div>
                <span className="font-medium">Atendimento 24 Horas</span>
              </div>
              <div className="flex items-center space-x-2 text-white">
                <div className="w-8 h-8 bg-blue-500 rounded-full flex items-center justify-center">
                  <i className="ri-timer-line text-sm"></i>
                </div>
                <span className="font-medium">Chegamos em até 30 Minutos</span>
              </div>
              <div className="flex items-center space-x-2 text-white">
                <div className="w-8 h-8 bg-yellow-500 rounded-full flex items-center justify-center">
                  <i className="ri-price-tag-3-line text-sm"></i>
                </div>
                <span className="font-medium">Cobrimos Orçamento!</span>
              </div>
            </div>

            <div className="mb-8">
              <button
                onClick={handleCall}
                className="flex items-center justify-center lg:justify-start space-x-3 text-white hover:text-green-300 transition-colors cursor-pointer"
              >
                <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center">
                  <i className="ri-whatsapp-line text-xl"></i>
                </div>
                <div className="text-left">
                  <div className="text-lg font-bold">(19) 98186-8997</div>
                  <div className="text-sm opacity-90">Clique para ligar agora</div>
                </div>
              </button>
            </div>

            <div className="flex flex-col sm:flex-row items-center space-y-4 sm:space-y-0 sm:space-x-4">
              <button
                onClick={handleWhatsApp}
                className="w-full sm:w-auto bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105 flex items-center justify-center space-x-2 whitespace-nowrap shadow-lg"
              >
                <i className="ri-whatsapp-line"></i>
                <span>Orçamento Grátis pelo WhatsApp</span>
              </button>
              <button
                onClick={handleCall}
                className="w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white px-8 py-4 rounded-lg font-bold text-lg transition-all transform hover:scale-105 flex items-center justify-center space-x-2 whitespace-nowrap shadow-lg"
              >
                <i className="ri-phone-line"></i>
                <span>Ligue Agora</span>
              </button>
            </div>

            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 lg:hidden">
              <button
                onClick={handleWhatsApp}
                className="w-16 h-16 bg-green-500 rounded-full flex items-center justify-center animate-bounce shadow-lg cursor-pointer"
              >
                <i className="ri-whatsapp-line text-white text-2xl"></i>
              </button>
            </div>
          </div>

          <div className="w-full lg:w-1/2 hidden lg:block"></div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
